import { render } from "./AuthenticatedAreaContainer.vue?vue&type=template&id=4351536b"
import script from "./AuthenticatedAreaContainer.vue?vue&type=script&lang=js"
export * from "./AuthenticatedAreaContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__